export default function IntroSection({ isVisible }) {
  return (
    <section
      id="intro"
      className={`py-24 lg:py-32 bg-[#F9F6F0] transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      data-testid="intro-section"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl lg:text-5xl font-medium text-[#1A1A1A] mb-8 heading-decorated-center">
          What I Do
        </h2>
        
        <div className="prose-creative text-base lg:text-lg space-y-6">
          <p className="text-[#4A4542] leading-relaxed">
            I'm a creative, people-centred Event Producer with over a decade of
            experience delivering live, digital and hybrid programmes across arts,
            culture and international contexts – most recently at the{" "}
            <span className="font-semibold text-[#1A1A1A]">National Theatre</span>.
          </p>
          
          <p className="text-[#4A4542] leading-relaxed">
            Alongside my producing work, I'm developing a practice as a{" "}
            <span className="font-semibold text-[#1A1A1A]">creative facilitator</span>{" "}
            specialising in drama-based approaches to communication, presence and
            confidence in the workplace.
          </p>
          
          <p className="text-[#4A4542] leading-relaxed">
            Drawing on rehearsal-room techniques, I create safe,
            structured spaces where individuals and teams can practise real-world
            challenges – from presenting with impact and navigating difficult
            conversations, to leading with clarity and authenticity.
          </p>
        </div>
      </div>
    </section>
  );
}
